export default "__VITE_PUBLIC_ASSET__46ac6074__"